import { gray } from '@synoptic/ui-kit/palette.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const content = style({
  color: themeVars.container.foreground.tertiary,
});

export const warning = style({
  color: themeVars.container.foreground.critical,
  textAlign: 'center',
  margin: `${space.s20}px 0 ${space.s32}px`,
});

export const actionButtons = style({
  display: 'flex',
  justifyContent: 'center',
  gap: space.s8,
});

export const addInfoContainer = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s16,
  marginTop: space.s20,
});

export const iconContainer = style({
  background: gray[800],
  borderRadius: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: space.s6,
  color: themeVars.color.icon.inverse,
});

export const addInfoContent = style([typography.bodyMd]);
